const Reset = Object.freeze({
  lookup: 'start',
  select: 'step 2',
  'lost-stolen': 'lost-stolen',
  complete: 'complete'
})

export default Reset
